<template>
  <div id="app" class="h-screen w-screen overflow-hidden bg-gray-50">
    <RouterView />
    <ToastContainer />
    <ConfirmDialog />
    <!-- Mounted once: every refused write in the app reports here. -->
    <AccessDeniedModal />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import ToastContainer from '@/components/ToastContainer.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import AccessDeniedModal from '@/components/AccessDeniedModal.vue'
</script>
